import React from 'react';
import useQueryObject from '../../shared/utils/useQueryObject';
import {Icon, Page, Row, Tile} from '../../shared';
import {isEntitled} from '../../shared/reducers/user';
import HoldingsTable from '../../shared/widgets/HoldingsTable';
import history from '../../history';
import {getBackPath} from '../shared/utils/dashboardUtils';
import debug from 'debug';

const log = debug('circleblack:investor:page:HoldingsPage');

const HoldingsPage = () => {
  log('rendering');
  const [context] = useQueryObject('context');

  const backPath = getBackPath();

  return <Page>
    {!isEntitled([{group: 'securities', feature: 'isCashEq', access: 'r'}])
            && <Tile key={'Holdings'}
                     title={'Holdings'}
                     icon={<Icon svg={'arrowCircle'}
                                 rotate={'180deg'}
                                 action={() => history.push(backPath)}/>}>
              <HoldingsTable
                    height={'fit-content'}
                    maxHeight={'calc(100vh - 200px)'} container={{id: context?.containerID, type: context?.type}} fullPage={true}/>
            </Tile>}
    {isEntitled([{group: 'securities', feature: 'isCashEq', access: 'r'}])
            && <Row wrap={true} height={'fit-content'}>
              <Tile key='Cash Holdings' height={'auto'}
                    title='Cash Holdings'
                    width={'40%'}
                    layout={{grow: 1}}
                    icon={<Icon svg={'arrowCircle'}
                                rotate={'180deg'}
                                action={() => history.push(backPath)}/>}>
                <HoldingsTable maxHeight={'calc(100vh - 200px)'}
                               container={{id: context?.containerID, type: context?.type}}
                               fullPage={true}
                               isCashEq={1}/>
              </Tile>
              <Tile key='Other Holdings' height={'fit-content'}
                    title='Other Holdings'
                    width={'40%'}
                    layout={{grow: 1}}
                    icon={<Icon svg={'arrowCircle'}
                                rotate={'180deg'}
                                action={() => history.push(backPath)}/>}>
                <HoldingsTable maxHeight={'calc(100vh - 200px)'}
                               container={{id: context?.containerID, type: context?.type}}
                               fullPage={true}
                               isCashEq={0}/>
              </Tile>
            </Row>}
  </Page>;
};

export default HoldingsPage;
